export default "__VITE_ASSET__b78208f4__"